import * as yaml from 'js-yaml';
import * as fs from 'fs';
import moment from 'moment';

const regexPicture = (exp: any, picture: any) => {
    const regex = new RegExp(exp);
    const out = [];
    const text = picture; // "9(10)V9(10)"
    let result = regex.exec(text);
    while (result) {
        out.push(result[1]);
        result = regex.exec(text);
    }
    return out;
};

/*
 * Alfanumérico (picture X): alinhados à esquerda com brancos à direita. Preferencialmente,
 * todos os caracteres devem ser maiúsculos. Aconselhase a não utilização de
 * caracteres especiais (ex.: “Ç”, “?”,, etc) e
 * acentuação gráfica (ex.: “Á”, “É”, “Ê”, etc) e os campos não utiliza dos deverão ser preenchidos com brancos.
 * */
const formatText = (value: any, size: any) => {
    value = value.replace(/[^a-zA-Z0-9 ]/g, '').substr(0, size);
    while (value.length < size) {
        value = value + ' ';
    }
    return value;
};

/*  Numérico (picture 9): alinhado à direita com zeros à esquerda e os campos não utilizados deverão ser preenchidos
* com zeros. - Vírgula assumida (picture V): indica a posição da vírgula dentro de um campo numérico.
* Exemplo: num campo com picture “9(5)V9(2)”, o número “876,54” será representado por “0087654”
* @param {*} picture
* @param {*} value
*/
const formatNumber = (value: any, size: number) => {
    if (value != undefined)
        value = value.replace(/[^0-9]/g, '');

    while (value.length < size) {
        value = '0' + value;
    }
    return value;
};

const formatDate = (value: any, size: any, dateformat: any) => {
    // if(!value){
    //   return new Date()
    // }
    // value = value.replace(/[^0-9]/g, "")
    while (value.length < size) {
        value = '0' + value;
    }
    // date_format: '%d%m%y'
    return value;
};

const formatCurrency = (value: any, number: any, decimal: any) => {
    if (!value) {
        value = '';
    }
    value += '';
    value = value.replace(/[.R$]/g, '');
    const vals = [];
    vals.push(value.slice(0, -decimal));
    vals.push(value.slice(-decimal));
    if (vals.length === 1) {
        vals[1] = '';
    }
    while (vals[0].length < number) {
        vals[0] = '0' + vals[0];
    }
    while (vals[1].length < decimal) {
        vals[1] = '0' + vals[1];
    }
    return vals[0] + vals[1];
};

export class YamlLine {
    public static makeLine(layout: any, data: any) {
        let line = '';
        const object: any = {};
        if (layout) {
            Object.keys(layout).forEach(key => {
                const item = layout[key];
                let value;
                if (key in data && data[key]) {
                    value = data[key];
                } else {
                    value = item.default;
                }
                const baseValue = value ? value + '' : '';
                const pictures = YamlLine.usePicture(item, baseValue);
                object[key] = pictures;
                line += pictures;
            });
        }
        return {line, object};
    }

    public static readLine(layout: any, data: any) {
        const object: any = {};
        if (layout) {
            Object.keys(layout).forEach(key => {
                const item = layout[key];
                if (item.pos) {
                    object[key] = YamlLine.extractDataFromPicture(item, data);
                } else {
                    console.warn('Nao tem posicao pra key', key);
                }
            });
        }
        return object;
    }

    public static extractDataFromPicture(item: any, value: any, ignoreDefault = false) {
        const start = item.pos[0] - 1; // yml começa no 1 e array em 0
        const length = item.pos[1] - item.pos[0] + 1;
        const timeZone = 'America/Sao_Paulo';
        if (value) {
            value = value.substr(start, length) || (ignoreDefault ? null : item.default);

            const {picture} = item;
            if (picture.indexOf('V9') > 0) {
                const out = regexPicture(/9\((\w+?)\)/g, picture);
                return parseFloat(`${value.substr(0, out[0])}.${value.substr(out[0], out[1])}`);
            } else if (picture.startsWith('9')) {
                // const out = regexPicture(/9\((\w+?)\)/g, picture);
                if (item.date_format) {
                    return moment(value, item.date_format).endOf('day').tz(timeZone).toDate();
                } else {
                    return parseInt(value, 10);
                }
            } else if (picture.startsWith('X')) {
                return value.trim();
            } else {
                throw new Error(`Cant recognize picture for ${picture}`);
            }

        } else {
            return null;
        }
    }
    public static readYaml(filename: any) {
        try {
            return yaml.safeLoad(fs.readFileSync(filename, `utf8`));
        } catch (e) {
            console.log(e);
            return null;
        }
    }

    public static usePicture = (item: any, value = '') => {
        const {picture} = item;
        if (picture.indexOf('V9') > 0) {
            const out = regexPicture(/9\((\w+?)\)/g, picture);
            return formatCurrency(value, out[0], out[1]);
        } else if (picture.startsWith('9')) {
            const out = regexPicture(/9\((\w+?)\)/g, picture);
            if (item.date_format) {
                return formatDate(value, out[0], item.date_format);
            } else {
                return formatNumber(value, parseInt(out[0], 10));
            }
        } else if (picture.startsWith('X')) {
            const out = regexPicture(/X\((\w+?)\)/g, picture);
            return formatText(value, out[0]);
        } else {
            throw new Error(`Cant recognize picture for ${picture}`);
        }
    }
}
